/* Six machines, three steps each, output first. Name the output, show the receipt. No em dashes. */

/* Real assets from a real store this system built end to end: ibdassist.com */
export const PROOF = {
  brand: "Axos · ibdassist.com",
  url: "https://www.ibdassist.com/",
  system: "https://www.ibdassist.com/cdn/shop/files/GUTsupport_and_HashiAid_1_f5137ac8-6d4b-406a-8e5b-3fe1352b6f7f.png?v=1770062038&width=800",
  hashi: "https://www.ibdassist.com/cdn/shop/files/AXOS_Mockup_3.png?v=1781822512&width=800",
  gut: "https://www.ibdassist.com/cdn/shop/files/AXOS_Mockup_4.png?v=1781822512&width=800",
};

export const MACHINES = [
  {
    id: "meta",
    name: "Meta",
    accent: "#4C9AFF",
    account: "META ADS · CREATIVE TESTING ENGINE",
    headline: "50 new ads. Live in your account. Every Monday.",
    sub: "Meta is not a targeting game anymore. It is a creative game, and this machine never runs out of creative.",
    kpi: {
      ltv: "Buys cheaper customers so the payback window closes sooner.",
      aov: "Puts the budget behind the ads that sell the bigger basket.",
    },
    magnet: { label: "Get your 10 ad sample batch", asset: "meta-sample-batch" },
    stat: { v: "-18%", l: "CPA after four weekly batches" },
    steps: [
      {
        tag: "The output",
        title: "This is Monday's batch",
        body: "Fifty statics, produced, named, launched. Eight shown, every hook lifted from a real review.",
        foot: "1,571 reviews read · your assets only · no invented claims",
        kind: "frames",
        data: {
          label: "Batch #34 · 50 statics · 8 shown",
          frames: [
            { hook: "Take the thyroid support quiz.", angle: "Quiz entry", src: "static · 3:4", img: "hashi" },
            { hook: "Thyroid support isn't one-size-fits-all.", angle: "Objection", src: "static · 3:4", img: "hashi" },
            { hook: "Designed for the gut and thyroid axis.", angle: "Mechanism", src: "static · 3:4", img: "gut" },
            { hook: "Stop guessing your supplement routine.", angle: "Frustration", src: "static · 3:4", img: "gut" },
            { hook: "Not every routine fits everyone.", angle: "Personalisation", src: "static · 3:4", img: "system" },
            { hook: "Them versus Axos, side by side.", angle: "Comparison", src: "static · 3:4", img: "system" },
            { hook: "A more guided way to start.", angle: "Process", src: "static · 3:4", img: "hashi" },
            { hook: "Your supplement routine, simplified.", angle: "Simplicity", src: "static · 3:4", img: "gut" },
          ],
        },
      },
      {
        tag: "The read",
        title: "It reads the creative, not the audience",
        body: "Every ad is an angle against an offer. That is the whole game now, and it is read every morning.",
        foot: "every ad tagged: offer · angle · who it speaks to",
        kind: "rows",
        data: {
          head: ["Ad", "Offer · angle · audience", "CPA", "Read"],
          rows: [
            ["#009", "Core offer | Doctor proof | Women 40+", "$38.20", { t: "winning", s: "ok" }],
            ["#014", "Core offer | Brain fog | Women 35+", "$41.60", { t: "winning", s: "ok" }],
            ["#031", "Quiz offer | Confused starter | New buyers", "$44.90", { t: "scaling", s: "ok" }],
            ["#022", "Core offer | Bloating | Gut buyers", "$71.30", { t: "fatiguing", s: "warn" }],
            ["#017", "Bundle offer | Simplicity | Subscribers", "$96.00", { t: "kill today", s: "danger" }],
          ],
          note: "Same offers, fresh angles every Monday. The account never runs out of things to test.",
        },
      },
      {
        tag: "All week",
        title: "Creative analysis, around the clock",
        body: "Every ad judged against every other ad. Winners fed, losers killed, fatigue caught before it costs you.",
        foot: "it can edit meta ads · one campaign at a time",
        kind: "log",
        data: [
          { k: "ok", t: "found", d: "Ad #012 from the new batch doing 15% better than every live ad" },
          { k: "ok", t: "scaled", d: "#012 moved out of the test cell, budget tripled" },
          { k: "ok", t: "killed", d: "#017 dead at $50 spent, twice the CPA of its batch" },
          { k: "ok", t: "caught", d: "Doctor proof angle fatiguing at frequency 3.4, refresh already in production" },
          { k: "ok", t: "fixed", d: "3 rejected ads rewritten and back live the same morning" },
          { k: "warn", t: "asking", d: "Wants $6,000 more a week behind #012. Your call." },
          { k: "dim", t: "receipt", d: "RUN-4417 · every change logged and reversible" },
        ],
      },
    ],
  },

  {
    id: "google",
    name: "Google",
    accent: "#FFC46B",
    account: "GOOGLE ADS · 24/7 OPTIMIZATION",
    headline: "A 24/7 optimization machine, running on your data.",
    sub: "Meta is won on creative. Google is won on data. Keywords, listings, ads and search terms, tuned around what your store actually sells.",
    kpi: {
      ltv: "Every overnight optimization compounds into a cheaper CPA and a faster payback.",
      aov: "Feeds budget to the searches that buy the bigger basket.",
    },
    magnet: { label: "Get your wasted spend audit", asset: "google-waste-audit" },
    stat: { v: "24/7", l: "optimizing on your live sales data" },
    steps: [
      {
        tag: "The output",
        title: "Last night, while you slept",
        body: "Optimizations run around the clock, each one backed by your own order data.",
        foot: "it can edit google ads · every move backed by order data",
        kind: "log",
        data: [
          { k: "ok", t: "02:14", d: "Bids raised on 6 keywords that produced orders yesterday" },
          { k: "ok", t: "02:31", d: "4 search terms with zero orders in 90 days blocked" },
          { k: "ok", t: "03:05", d: "Shopping listing titles rewritten to match what buyers actually type" },
          { k: "ok", t: "04:12", d: "Ad copy winner promoted: 4.1% click rate against 2.8%" },
          { k: "ok", t: "05:30", d: "Budget shifted to the search terms holding ROAS above 3" },
          { k: "warn", t: "06:00", d: "New campaign type proposed. New channel, needs your yes." },
          { k: "dim", t: "receipt", d: "RUN-4468 · 47 optimizations · all reversible" },
        ],
      },
      {
        tag: "The data",
        title: "It reads every real search, every morning",
        body: "Real people, real queries, judged on orders out of your own store data.",
        foot: "search terms · 30d · judged on orders, not clicks",
        kind: "rows",
        data: {
          head: ["Search term", "Cost", "Orders", "Intent", "Action"],
          rows: [
            ["best supplement for hashimotos", "$412", "9", "buying", { t: "bid raised", s: "ok" }],
            ["why am i always bloated", "$388", "0", "research", { t: "blocked", s: "danger" }],
            ["axos vs [competitor]", "$196", "6", "comparison", { t: "own it", s: "ok" }],
            ["cheap thyroid vitamins", "$241", "1", "price-led", { t: "blocked", s: "danger" }],
            ["gut and thyroid multivitamin", "$168", "7", "buying", { t: "bid raised", s: "ok" }],
            ["thyroid doctor near me", "$97", "0", "irrelevant", { t: "blocked", s: "danger" }],
          ],
          note: "Buying intent gets funded. Research and price shopping gets blocked. Every morning.",
        },
      },
      {
        tag: "The buy",
        title: "Then it buys what the data proves",
        body: "Each keyword comes with an estimate built from your numbers, not an industry average.",
        foot: "proposals ranked on your contribution data",
        kind: "rows",
        data: {
          head: ["Add", "Match", "Campaign", "Est. monthly", "Risk"],
          rows: [
            ["best supplement for hashimotos", "exact", "NB–Solutions", "$1,900", { t: "low", s: "ok" }],
            ["gut and thyroid multivitamin", "exact", "NB–Product", "$1,400", { t: "low", s: "ok" }],
            ["axos vs [competitor]", "phrase", "Brand–Defence", "$800", { t: "low", s: "ok" }],
            ["supplements for ibd", "exact", "NB–Solutions", "$600", { t: "untested", s: "warn" }],
          ],
          note: "Brand gets split out, so non brand stops borrowing brand's efficiency.",
        },
      },
    ],
  },

  {
    id: "klaviyo",
    name: "Klaviyo",
    accent: "#A78BFA",
    account: "KLAVIYO · LIFECYCLE FLOWS",
    headline: "Eleven automated flows, a split test at every step.",
    sub: "Welcome, abandoned cart, post purchase, winback. Built out once, then always testing.",
    kpi: {
      ltv: "Pulls order two forward, which is the fastest way to close the payback window.",
      aov: "Sells the bigger bundle inside the flow instead of discounting to get a click.",
    },
    magnet: { label: "Get your flow split test plan", asset: "klaviyo-flow-plan" },
    stat: { v: "48.9%", l: "open rate on the winning subject line" },
    steps: [
      {
        tag: "The output",
        title: "The emails your customers actually get",
        body: "Your list broken into segments: new subscribers, cart abandoners, first time buyers, lapsed customers. Each gets its own flow, and every email carries a test.",
        foot: "klaviyo · 4 segments shown · every step split tested",
        kind: "live",
        data: {
          label: "Live flows · one email per segment",
          frames: [
            { key: "emails", tab: "Emails", route: "/axos/emails", url: "welcome · reminder · abandoned cart · day 28", title: "Four segments, four flows, a live test in each", w: 1000, h: 470 },
          ],
        },
      },
      {
        tag: "Built split",
        title: "Every step ships as a split test",
        body: "Subject line, block order, incentive, send time. One variable each.",
        foot: "4 steps · 8 variants · one variable each",
        kind: "tree",
        data: {
          title: "Winback 90d · v14",
          stages: [
            { n: "Step 1 · Day 0", a: "Subject: your thyroid numbers are not the whole story", b: "Subject: the gut side nobody checked", test: "subject line" },
            { n: "Step 2 · Day 3", a: "Proof above the offer", b: "Offer above the proof", test: "block order" },
            { n: "Step 3 · Day 7", a: "15% off on subscribe", b: "Free shipping, no expiry", test: "incentive type" },
            { n: "Step 4 · Day 14", a: "Send 10:00 local", b: "Send 19:00 local", test: "send time" },
          ],
        },
      },
      {
        tag: "Read cold",
        title: "Winners called on open and click rate",
        body: "A step gets called when the numbers earn the call. Anything short keeps running.",
        foot: "read on the metric that matters per step",
        kind: "rows",
        data: {
          head: ["Step", "Metric", "A", "B", "Call"],
          rows: [
            ["1 · subject line", "open rate", "41.2%", "48.9%", { t: "B wins · 97%", s: "ok" }],
            ["2 · block order", "click rate", "3.1%", "2.4%", { t: "A wins · 95%", s: "ok" }],
            ["3 · incentive", "revenue / recipient", "$1.42", "$1.39", { t: "keep running", s: "warn" }],
            ["4 · send time", "click rate", "2.8%", "2.9%", { t: "keep running", s: "warn" }],
          ],
          note: "Step 3 is close and the margin differs, so it is not called on revenue alone.",
        },
      },
    ],
  },

  {
    id: "cro",
    name: "CRO",
    accent: "#5FE3A1",
    account: "SHOPIFY · PDP + LANDING PAGES",
    headline: "A new page test live every week. Fifty two a year.",
    sub: "One built variant, one change, one clean read. Not a deck of recommendations somebody has to build.",
    kpi: {
      ltv: "Tests subscribe rate and the commitment on order one, not just add to cart.",
      aov: "Tests the bundle ladder on the page, which is where order value is actually decided.",
    },
    magnet: { label: "Get your PDP teardown and first test", asset: "cro-pdp-teardown" },
    stat: { v: "+3.4%", l: "more orders from the last shipped test" },
    steps: [
      {
        tag: "The output",
        title: "The page and the quiz, live",
        body: "Built, shipped, still being tested block by block. Flip between them.",
        foot: "shopify theme · quiz on quiz.ibdassist.com",
        kind: "live",
        data: {
          label: "Live pages · Axos",
          frames: [
            { key: "landing", tab: "Landing page", route: "/axos", url: "axos · quiz landing page", title: "Landing page, 8 tests logged on it", w: 1280, h: 470 },
            { key: "quiz", tab: "Quiz", route: "/axos/quiz", url: "axos · three question quiz", title: "Quiz, 5 tests logged on it", w: 1280, h: 470 },
          ],
        },
      },
      {
        tag: "The record",
        title: "Every test dated, measured, on the record",
        body: "Real launches with real reads. Wins ship to everyone, misses get reverted and logged.",
        foot: "52 shots a year at the number that pays for everything",
        kind: "rows",
        data: {
          head: ["Test", "Offer", "Launched", "Result", "Status"],
          rows: [
            ["Routine builder above the fold", "Core offer", "May 12", "+4.1% CVR", { t: "shipped", s: "ok" }],
            ["Subscribe saving in the buy box", "Subscription", "May 26", "+2.6% CVR", { t: "shipped", s: "ok" }],
            ["Photo reviews above ingredients", "Core offer", "Jun 2", "+1.1% so far", { t: "reading", s: "warn" }],
            ["Urgency banner on the cart", "Sitewide", "May 19", "-0.8% CVR", { t: "reverted", s: "danger" }],
            ["Bundle ladder on the collection", "Bundle offer", "Jun 9", "queued", { t: "next up", s: "dim" }],
          ],
          note: "Misses are on the record too. That is what makes the wins believable.",
        },
      },
      {
        tag: "One change",
        title: "It builds the variant and stages it",
        body: "A real control and a real variant, one change, inside your theme. Nothing live until you clear it.",
        foot: "staged as a draft · diff attached · nothing live",
        kind: "wire",
        data: {
          control: ["Gallery", "Title + price", "Add to cart", "Ingredients", "Reviews", "FAQ"],
          variant: ["Gallery", "Title + price", "Routine builder", "Add to cart", "Photo reviews", "Ingredients", "FAQ"],
          changed: ["Routine builder", "Photo reviews"],
        },
      },
    ],
  },

  {
    id: "creative",
    name: "Creative",
    accent: "#FF8FA3",
    account: "CREATIVE · ANGLES · BRIEFS · VARIANTS",
    headline: "It reads 1,571 reviews and turns them into ads you can run.",
    sub: "The exact words your customers used, kept word for word, produced into statics and pages.",
    kpi: {
      ltv: "Attracts the people who stay, in the language of the ones who already did.",
      aov: "Sells the full system instead of the cheapest way in.",
    },
    magnet: { label: "Get your customer language angle bank", asset: "creative-angle-bank" },
    stat: { v: "1,571", l: "reviews mined for hooks, word for word" },
    steps: [
      {
        tag: "The output",
        title: "A new advertorial or listicle, weekly",
        body: "Where the click lands when the direct ad tires. Real pages, not decks.",
        foot: "built as real pages · disclosure in the masthead",
        kind: "live",
        data: {
          label: "Live pages · where the traffic lands",
          frames: [
            { key: "advertorial", tab: "Advertorial", route: "/axos/advertorial", url: "axos · advertorial", title: "Advertorial, 5 tests logged on it", w: 1280, h: 470 },
            { key: "listicle", tab: "Listicle", route: "/axos/listicle", url: "axos · listicle", title: "Listicle, 5 tests logged on it", w: 1280, h: 470 },
          ],
        },
      },
      {
        tag: "Where it came from",
        title: "Your customers already wrote the ads",
        body: "Themes come out with the wording attached, never paraphrased.",
        foot: "1,571 reviews · 96 tickets · verbatim retained",
        kind: "rows",
        data: {
          head: ["Verbatim", "Source", "Theme", "Seen", "Use"],
          rows: [
            ["“My doctor is shocked.”", "review", "Third party proof", "38×", { t: "lead angle", s: "ok" }],
            ["“Which one do I start with?”", "ticket", "Choice confusion", "19×", { t: "lead angle", s: "ok" }],
            ["“Day 28 and I feel steady.”", "review", "Progress", "14×", { t: "support", s: "ok" }],
            ["“One capsule, not six.”", "review", "Simplicity", "11×", { t: "support", s: "ok" }],
            ["“Wish there was a smaller size.”", "ticket", "SKU gap", "9×", { t: "product note", s: "warn" }],
          ],
          note: "The SKU gap gets routed to you, not written into a hook.",
        },
      },
      {
        tag: "Then produced",
        title: "And handed to the ad account",
        body: "Named to convention, versioned, passed to Meta as a test cell.",
        foot: "handed to the Meta machine as batch #34",
        kind: "frames",
        data: {
          label: "Produced · ready for the ad account",
          frames: [
            { hook: "“My doctor is shocked.”", angle: "Third party proof", src: "Static", img: "hashi" },
            { hook: "Which one do you start with?", angle: "Choice", src: "Static", img: "system" },
            { hook: "Day 28 and steady.", angle: "Progress", src: "UGC · 20s", img: "gut" },
            { hook: "One capsule. Not six.", angle: "Simplicity", src: "Static", img: "gut" },
          ],
        },
      },
    ],
  },

  {
    id: "reporting",
    name: "Reporting",
    accent: "#7DD3FC",
    account: "REPORTING · EVERY DAY, ON THE RECORD",
    headline: "You watch the week happen. You never have to ask.",
    sub: "The live board from the top of the page is the product: every day, one flagship action, receipts on everything.",
    kpi: {
      ltv: "Payback period at the top of the page. Everything else sits below it.",
      aov: "MER and order value at the top of the page. Everything else sits below it.",
    },
    magnet: { label: "Get a sample Monday one pager", asset: "reporting-sample-page" },
    stat: { v: "47", l: "actions on the record every week" },
    steps: [
      {
        tag: "The output",
        title: "The week, reported as it happens",
        body: "Seven days of shipped work, streamed live. Click any day.",
        foot: "standing job · daily receipts · Monday one pager",
        kind: "report",
        data: {},
      },
      {
        tag: "Your format",
        title: "Delivered exactly how your brand wants it",
        body: "Same report, any shape. A designed PDF, a Slack message, an email, a live dashboard or a slide deck. Skinned to your brand, not ours.",
        foot: "same numbers · five formats · your logo on it",
        kind: "formats",
        data: {},
      },
      {
        tag: "Monday 06:00",
        title: "It builds the numbers itself",
        body: "Five sources on the same definitions. Nobody argues about which revenue number is real.",
        foot: "5 sources · same definitions every week",
        kind: "rows",
        data: {
          head: ["Metric", "This week", "vs prior", "vs 4wk", "Flag"],
          rows: [
            ["Revenue", "$248,100", "+6.2%", "+3.1%", { t: "on track", s: "ok" }],
            ["Blended CAC", "$54.20", "+11.8%", "+9.4%", { t: "watch", s: "warn" }],
            ["CVR · product page", "3.42%", "+3.4%", "+1.8%", { t: "test win shipped", s: "ok" }],
            ["Email revenue share", "28.4%", "+1.9%", "+0.8%", { t: "on track", s: "ok" }],
            ["Repeat rate 60d", "21.6%", "−0.4%", "−1.1%", { t: "investigate", s: "warn" }],
          ],
          note: "Two flags. Both already actioned or escalated.",
        },
      },
      {
        tag: "Already handled",
        title: "It shows what it already did about it",
        body: "Forty seven actions taken, two waiting on you, kept separate so you find them in ten seconds.",
        foot: "47 actions taken · 2 waiting on a person",
        kind: "log",
        data: [
          { k: "ok", t: "done", d: "Worn out ad capped, fresh batch launched in a test cell" },
          { k: "ok", t: "done", d: "Google bids and budgets re-tuned overnight on order data" },
          { k: "ok", t: "done", d: "Winning emails promoted, new challengers built to beat them" },
          { k: "ok", t: "done", d: "Page test won and shipped, the miss reverted and logged" },
          { k: "warn", t: "needs you", d: "Raise weekly ad spend by $6,000. Real money, your call." },
          { k: "warn", t: "needs you", d: "Repeat buyers dipped. Two theories, pick which to fund." },
          { k: "dim", t: "receipts", d: "47 actions, each with a diff and an undo" },
        ],
      },
    ],
  },
];
